import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
// eslint-disable-next-line css-modules/no-unused-class
import Button from "web/react/components/button/button";
import styles from "./social-button.module.css";

const TYPE_CLASSES = {
    facebook: styles.facebook,
    google: styles.google,
};

export default function SocialButton({ className, type, ...props }) {
    const typeClass = TYPE_CLASSES[type];
    if (!typeClass) {
        throw new Error(`Unknown type ${type}!`);
    }
    return <Button className={clsx(className, typeClass)} styleType="cta" {...props} />;
}

SocialButton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    fullWidth: PropTypes.bool,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(["facebook", "google"]).isRequired,
};
